const configuredApiBaseUrl = import.meta.env.VITE_API_BASE_URL?.trim();

const apiBaseUrl = configuredApiBaseUrl
    ?? (import.meta.env.DEV ? 'http://localhost:3000' : '');

export function apiUrl(path: string): string {
    const normalizedBaseUrl = apiBaseUrl.replace(/\/+$/, '');
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;

    return `${normalizedBaseUrl}${normalizedPath}`;
}